import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import DashboardForLoanType from './DashboardForLoanType';

const DEFAULT_LOAN_TYPE = 'LAP';

export default function DashboardHome({ userProfile }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const loanType = searchParams.get('loan_type');
	const setLoanType = (loanTypeCode) => setSearchParams((searchParams) => {
		searchParams.set('loan_type', loanTypeCode);
		searchParams.delete('status');
		if (loanTypeCode === 'null') {
			searchParams.delete('page');
		}
		return searchParams;
	});

	// The dashboard used to open on a loan-type picker. It now goes straight to
	// LAP; every other loan type is still reachable from the select in
	// DashboardForLoanType.
	useEffect(() => {
		if (!loanType) {
			setSearchParams((params) => {
				params.set('loan_type', DEFAULT_LOAN_TYPE);
				return params;
			}, { replace: true });
		}
	}, [loanType, setSearchParams]);

	if (!loanType) {
		return null;
	}

	return (
		<DashboardForLoanType
			loanType={loanType}
			userProfile={userProfile}
			setLoanType={setLoanType}
		/>
	);
}
